import { ListItem, Grid } from '@mui/material';
import { DocumentTypes, InspectFileState } from 'types';
import { useDispatch, useSelector } from 'react-redux';
import GVTypography from 'components/lib/GVTypography/GVTypography';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import { format } from 'date-fns';
import getFileIconFromExtension, { getMergedFileIcon } from './FileHelpers';
import getFileName from './FileNameHelper';
import { makeStyles } from 'tss-react/mui';
import { preprocessFile } from 'store/requests';
import { getUnavailableFiles } from 'store/app/appSelectors';

interface FileItem {
  file: InspectFileState;
  document: DocumentTypes;
  index: number;
}

const useStyles = makeStyles()((theme) => ({
  listItem: {
    maxWidth: '100%',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
    },
  },
  fileIcon: {
    marginRight: theme.spacing(1),
  },
  rightTitle: {
    textAlign: 'right',
  },
  // vertical alignment of the text
  lineAlignment: {
    lineHeight: '25px',
  },
}));

const FileItem = (props: FileItem) => {
  const { file, index, document } = props;
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const unavailableFiles = useSelector(getUnavailableFiles);
  const isUnavailable = unavailableFiles.includes(file.fileId);
  let fileIconElement;
  if (file.mergedFileData && file.mergedFileData.length > 0) {
    fileIconElement = getMergedFileIcon(file.mergedFileData);
  } else {
    fileIconElement = getFileIconFromExtension(file.originalName, file.fileMetadata?.containsType3Font);
  }
  const handleClickFile = () => {
    if (isUnavailable) return;
    dispatch(preprocessFile(file, props.document));
  };

  const listItem = (
    <ListItem
      disableGutters
      className={classes.listItem}
      key={file.fileId}
      id={`${document}-FileNumber-${index}`}
      onClick={handleClickFile}
    >
      <Grid container>
        <Grid item container xs={9}>
          <Grid item className={classes.fileIcon}>
            {fileIconElement}
          </Grid>
          <Grid
            item
            xs={10}
            style={{
              width: 0, // this width is being set to fix an issue where long file names cause parent to container to be too wide VE-5693
            }}
          >
            <GVTypography
              className={classes.lineAlignment}
              variant="body1"
              color={isUnavailable ? 'textSecondary' : 'textPrimary'}
              emphasis={isUnavailable ? 'disabled' : 'superhigh'}
              fontWeight={600}
              noWrap
            >
              {getFileName(file)}
            </GVTypography>
          </Grid>
        </Grid>
        <Grid item xs={3} className={classes.rightTitle}>
          <GVTypography
            className={classes.lineAlignment}
            variant="body1"
            color={isUnavailable ? 'textSecondary' : 'textPrimary'}
            emphasis={isUnavailable ? 'disabled' : 'medium'}
            fontWeight={600}
          >
            {format(new Date(file.createdAt), 'dd/MM/yyyy - HH:mm')}
          </GVTypography>
        </Grid>
      </Grid>
    </ListItem>
  );

  if (isUnavailable) {
    return (
      <GVTooltip title="This file is no longer available" side="left">
        <span>{listItem}</span>
      </GVTooltip>
    );
  }

  return listItem;
};

export default FileItem;
